export default __webpack_public_path__ + "static/media/gm.3c66b459.svg";